module.exports = __webpack_public_path__ + "public/SiteIcons/pwdHidden.svg?3cf65c47";